/* @flow weak */
import { ActionTypes as PaymentAccountActionTypes } from '../constants/PaymentAccountConstants';

export const initialState = {
  paymentAccount: null,
};

export function reducer(state = initialState, action) {
  switch (action.type) {
    case PaymentAccountActionTypes.LOAD_PAYMENT_ACCOUNT:
    case PaymentAccountActionTypes.PATCH_PAYMENT_ACCOUNT:
      return { ...state, paymentAccount: action.paymentAccount };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/payments/reducers/PaymentAccount.js